
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/applications/[slug]",
      function () {
        return require("private-next-pages/applications/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/applications/[slug]"])
      });
    }
  